<template>
  <v-container class="py-0 max-width-1200">
    <v-row class="text-left justify-center">

      <v-col cols="12" sm="8" class="px-6 border-right-light">
        <v-row>
          <v-col class="pb-0 overline">
            {{ $t("contact.subtitle") }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0 display-1">
            {{ $t("contact.title") }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ml-4 max-width-48">
            <v-icon dark>
              mdi-mail
            </v-icon>
          </v-col>
          <v-col>
            {{ $t("contact.text.mail") }}<br>
            <span id="showEmailSpan" v-if="!showEmail" class="caption mouse-hover-link" @click="toggleShowEmail()">{{ $t("common.showEmail") }}</span>
            <span id="emailSpan" v-if="showEmail" class="caption mouse-hover-link" @click="openMail('info@rubin.hu')">info@rubin.hu</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ml-4 max-width-48">
            <v-icon dark>
              mdi-phone
            </v-icon>
          </v-col>
          <v-col>
            {{ $t("contact.text.phone") }}<br>
            <!-- <span class="caption mouse-hover-link mr-4" @click="openPhone('+3614694020')">+36 1 469 40 20</span><span class="overline mouse-hover-link" @click="openCallBackDialog()">Visszahívást kérek</span> -->
            <span id="showPhoneNumberSpan" v-if="!showPhoneNumber" class="caption mouse-hover-link mr-4" @click="toggleShowPhoneNumber()">{{ $t("common.showPhoneNumber") }}</span>
            <span id="phoneNumberSpan" v-if="showPhoneNumber" class="caption mouse-hover-link mr-4" @click="openPhone('+3614694020')">+36 1 469 40 20</span>
            <!-- <span class="overline mouse-hover-link" @click="openCallBackDialog()">Visszahívást kérek</span> -->
          </v-col>
        </v-row>

        <!-- apple business chat -->
        <!-- <v-row>
          <v-col class="ml-4 pb-0 max-width-48">
            <v-icon dark>
              mdi-chat-processing
            </v-icon>
          </v-col>
          <v-col class="pb-0" v-if="!appleBusinessChatIsSupported">
            {{ $t(appleBusinessChatIsSupportMessage) }}<br>
            <span @click="checkIfBusinessChatIsSupported()" class="overline mouse-hover-link">{{ $t('businessChat.recheck') }}</span>
          </v-col>
        </v-row> -->

        <!-- <v-row v-if="appleBusinessChatIsSupported">
          <div
            class="apple-business-chat-banner-container"
            style="padding-top: 0!important;"
            data-apple-business-id="2cdf4b63-1609-40e6-86b5-0517c94bd500">
          </div>
          <v-col class="pt-0" style="margin-left: 40px">
            <div
              class="apple-business-chat-banner-container"
              style="padding-top: 0!important;"
              data-apple-business-id="2cdf4b63-1609-40e6-86b5-0517c94bd500"
              data-apple-banner-cta="Kérdése van? Segítünk!"
              data-apple-banner-context="Lépjen velünk kapcsolatba chat szolgáltatásunkon keresztül! Információ gyorsan, személyre szabottan."
              data-apple-banner-rounded-corners="false"
              data-apple-banner-background-color="rgb(169, 18, 51)"
              data-apple-banner-text-color="rgb(255, 255, 255)"
              data-apple-banner-icon-background-color="rgb(255, 255, 255)"
              data-apple-banner-icon-color="rgba(169, 18, 51, 1)">
            </div>
          </v-col> -->

          <!-- check this later -->
          <!-- https://developer.apple.com/documentation/businesschat/adding_a_business_chat_button_to_your_website -->
          <!-- <div
            class="apple-business-chat-message-container"
            data-apple-business-id="ca0db090 <truncated>"
            data-apple-icon-color="#1B3F68"
            data-apple-icon-background-color="#1B3F68"
            data-apple-icon-scale="1.7"
            data-apple-icon-title="Style questions? We can help.">
          </div> -->

        <!-- </v-row> -->

        <!-- <v-row>
          <v-col>
            <v-text-field
              label="email cím"
              dark
              outlined
              hide-details>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              label="üzenet"
              dark
              outlined
              hide-details>
            </v-textarea>
          </v-col>
        </v-row> -->
      </v-col>

      <v-col cols="12" sm="4" class="px-6">
        <v-col class="justify-end text-end">
          <img
            src="@/assets/logo-flat-light.svg"
            loading="lazy"
            alt="Rubin Infomatika logó"
            height="80" width="80">
        </v-col>
        <v-col class="pt-0">
          <v-row>
            <v-col class="pb-0 text-end caption text-uppercase">
              Rubin Informatikai Zrt.
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0 pt-1 text-end caption">
              1149 Budapest, Egressy út 17-21.
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col id="showPhoneNumber" class="pb-0 pt-1 text-end caption mouse-hover-link" @click="showPhoneNumber()">
              {{ $t("common.showPhoneNumber") }}
            </v-col>
            <v-col id="phoneNumber" class="pb-0 pt-1 text-end caption mouse-hover-link" @click="openPhone('+3614694020')">
              +36 1 469 40 20
            </v-col>
          </v-row> -->
        </v-col>

      </v-col>

    </v-row>

    <!-- DIALOG -->

    <v-dialog
      v-model="callBack.dialog"
      width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{$t("contact.callBack.title")}}
          </span>
        </v-card-title>
        <v-card-subtitle class="pt-2">
          <span>
            {{$t("contact.callBack.subtitle")}}
          </span><br>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text class="pt-4 text-justify max-height-500 overflow-y">
          <v-row justify="center">
            <v-col>
              <v-text-field
                v-model="callBack.input.name"
                outlined filled
                hide-details
                :label="$t('common.name')">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col>
              <v-text-field
                v-model="callBack.input.email"
                outlined filled
                hide-details
                :label="$t('common.phoneNumber')">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeCallBackDialog()">
            {{ $t("common.close") }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="sendCallBackRequest()">
            {{ $t("common.send") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Contact',
    extends: DataComponentBase,

    data: () => ({
      callBack: {
        dialog: false,
        input: {
          name: "",
          email: "",
          phoneNumber: "",
        }
      },
    }),
    created() {
      // this.initializeAppleChatBanner();
    },
    mounted() {
      // this.initializeAppleChatBanner();
    },

    computed: {
      // appleBusinessChatIsSupportMessage() {
      //   if(!window.appleBusinessChat.isSupported()) {
      //     return('businessChat.appleNotSupported');
      //   } else {
      //     return('businessChat.appleSupported');
      //   }
      // },
      // appleBusinessChatIsSupported() {
      //   return window.appleBusinessChat.isSupported()
      //   // return true
      // },
    },

    methods: {
      openMail(email) {
        window.location ='mailto:' + email;
      },
      openPhone(phoneNumber) {
        window.location ='tel:' + phoneNumber;
      },
      // dynamicallyCreateABannerPlaceholder() {
      //   var refreshPlaceholder = document.getElementById("refreshPlaceholder");
      //   refreshPlaceholder.classList.add("apple-business-chat-banner-container");
      //   refreshPlaceholder.setAttribute("data-apple-business-id", "ca0db090 <truncated>");
      //   refreshPlaceholder.setAttribute("data-apple-banner-cta", "Questions? We can help.");
      //   refreshPlaceholder.innerHTML = "Placeholder created.";
      // },
      // initializeAppleChatBanner() {
      //   window.appleBusinessChat.refresh();
      //   console.log('initializeAppleChatBanner')
      //   console.log(window.appleBusinessChat)
      // },
      // checkIfBusinessChatIsSupported() {
      //   if(!window.appleBusinessChat.isSupported()) {
      //     alert("Business Chat is not supported");
      //   } else {
      //     alert("Business Chat is supported");
      //   }
      //   this.initializeAppleChatBanner();
      // },
      openCallBackDialog() {
        this.callBack.dialog = true;
      },
      closeCallBackDialog() {
        this.callBack.dialog = false;
      },
      sendCallBackRequest() {
        this.closeCallBackDialog();
      },
    }
  }
</script>
